import CbpmnPropertiesProvider from './CbpmnPropertiesProvider';

export default {
  __init__: ['propertiesProvider'],
  propertiesProvider: ['type', CbpmnPropertiesProvider]
};
